//#region Imports
import React, { useEffect, useRef, useState } from 'react';
//MUI
import { Box, Popover, Typography, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText, Button } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import eOpsLogo from '../../../images/eops.png';
import excel from '../../../images/excel.png';
import pdf from '../../../images/pdf.png';
import print from '../../../images/print.png';
import { cfpBaseUrl } from '../../../network/urls';
import { companyName, companyShortName, convertDate, convertDatewithTime, getLogo, getName, printStamp, subdivisionName } from '../../../services/Functions';
import { internalIconStyles } from '../../../style/common';
import '../../../style/common.scss';


const LinemanStaffPerformance = () => {
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, roleId } = useSelector(state => state.auth)
    const [isLoading, setIsLoading] = React.useState(false);
    const { officeCode: offCode } = useSelector(state => state.officeCode)
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [totals, setTotals] = useState({});
    // const [officeCode, setOfficeCode] = useState('');
    const [dateFrom, setDateFrom] = useState(getCurrentDate())
    const [dateTo, setDateTo] = useState(getCurrentDate())
    const tableRef = useRef(null);
    const [dateFromDisplay, setDateFromDisplay] = useState('')
    const [dateToDisplay, setDateToDisplay] = useState('')
    const [category, setCategory] = useState('')
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [circleCode, setCircleCode] = useState('');
    const [circleName, setCircleName] = useState('');
    const [officeCode, setOfficeCode] = useState('');
    const [officeName, setOfficeName] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRemarks, setSelectedRemarks] = useState('');
    const [selectedPerson, setSelectedPerson] = useState('');
    const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
    const [selectedPerson1, setSelectedPerson1] = useState('');
    const [registeredByOptions, setRegisteredByOptions] = useState([]);
    const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");

    const [desginationList, setDesginationList] = useState([]);
    const [complaintList, setComplaintList] = useState([]);

    const [companyCode, setCompanyCode] = useState('15')
    const [selectedDesignations, setSelectedDesignations] = useState([1135]);
    const [selectedDesignationsForApi, setSelectedDesignationsForApi] = useState("1135");

    const [selectedComplaint, setSelectedComplaint] = useState([1]);
    const [selectedComplaintForApi, setSelectedComplaintForApi] = useState("1");


    useEffect(() => {
        setOfficeCode(circleCode);
    }, [circleCode]);

    const handleCircleChange = (event) => {
        const selectedCircleCode = parseInt(event.target.value);
        if (selectedCircleCode) {
            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circleName = filteredCircles.find(circle => circle.circleCode === selectedCircleCode)?.circleName || "";
            setOfficeName(circleName.concat(' Circle'));
            setCircleName(circleName);
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);
            const uniqueDivisions = subDivisions
                .filter(item => item.circleCode === selectedCircleCode)
                .reduce((acc, item) => {
                    if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                        acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        } else {
            if (roleTypeName == "Technical") {
                if (offCode) {
                    setCircleCode('');
                    setOfficeCode(offCode == 10 ? 15 : offCode);
                    let officeName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions)
                    setOfficeName(officeName.concat(' Region'));
                    setCircleName('');
                    setSelectedDivision('');
                    setSelectedSubDivision('');
                    setFilteredSubDivisions([]);
                    let circles = subDivisions.reduce((acc, curr) => {
                        if (!acc.some(item => item.circleCode === curr.circleCode)) {
                            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName });
                        }
                        return acc;
                    }, []);
                    setFilteredCircles(circles)
                }
            }
            else if (roleTypeName == "Commercial") {
                if (cfcLevelId == 2) {
                    if (offCode) {
                        setOfficeCode(offCode.toString().slice(0, 2))
                        let offName = cscID
                        setOfficeName(offName)
                        setHierarchy(cfcLevelId)
                    }
                } else if (cfcLevelId == 3) {
                    if (offCode) {
                        setOfficeCode(offCode.toString().slice(0, 3))
                        let offName = cscID
                        setOfficeName(offName)
                        setHierarchy(cfcLevelId)
                    }
                }
            }
        }
    };

    const handleDivisionChange = (e) => {
        const selectedDivisionCode = parseInt(e.target.value);
        if (selectedDivisionCode) {
            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || "";
            setOfficeName(divisionName.concat(' Division'));
            setSelectedSubDivision('');
            const uniqueSubDivisions = subDivisions
                .filter(item => item.divisionCode == selectedDivisionCode)
                .reduce((acc, item) => {
                    if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                        acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName });
                    }
                    return acc;
                }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
        }
        else {
            setSelectedDivision('');
            setOfficeCode(circleCode ? circleCode : offCode);
            let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions)
            setOfficeName(officeName.concat(' Circle'));
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);
            const uniqueDivisions = subDivisions
                .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
                .reduce((acc, item) => {
                    if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                        acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName });
                    }
                    return acc;
                }, []);
            setFilteredDivisions(uniqueDivisions);
        }
    };

    const handleSubDivisionChange = (e) => {
        const selectedSubDivisionCode = parseInt(e.target.value);
        if (selectedSubDivisionCode) {
            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(' Sub Division'));
        } else {
            setSelectedSubDivision('');
            let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions)
            setOfficeName(officeName.concat(' Division'))
            setOfficeCode(selectedDivision ? selectedDivision : offCode);
        }
    };

    // const handleChange = (event) => {
    //     const {
    //         target: { value },
    //     } = event;
    //     setSelectedComplaint(typeof value === 'string' ? value.split(',') : value);
    // };


    const handleChange = (event) => {
        // setSelectedDesignations(event.target.value);
        const selectedValues = event.target.value; // e.g., [1135, 96, 98]
        // const selectedString = selectedValues.join(','); // e.g., "1135,96,98"
        setSelectedDesignations(event.target.value);
        const selectedString = selectedValues.join(','); // e.g., "1135,96,98"
        console.log(selectedString, 'selectedString')
        setSelectedDesignationsForApi(selectedString);
    };

    const handleChange1 = (event) => {
        // setSelectedComplaint(event.target.value);
        const selectedValues = event.target.value;
        setSelectedComplaint(event.target.value);
        const selectedString = selectedValues.join(',');
        console.log(selectedString, 'selectedString')
        setSelectedComplaintForApi(selectedString);
    };
    useEffect(() => {
        if (roleTypeName == "Technical") {
            if (offCode) {
                setOfficeCode(offCode == 10 ? 15 : offCode)
                let offName = getName(offCode == 10 ? 15 : offCode, subDivisions)
                setOfficeName(offName)
                setHierarchy(offCode.length)
            }
        }
        else if (roleTypeName == "Commercial") {
            if (cfcLevelId == 2) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 2))
                    let offName = cscID
                    setOfficeName(offName)
                    setHierarchy(cfcLevelId)
                }
            } else if (cfcLevelId == 3) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 3))
                    let offName = cscID
                    setOfficeName(offName)
                    setHierarchy(cfcLevelId)
                }
            } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4))
                    let offName = cscID
                    setOfficeName(offName)
                    setHierarchy(cfcLevelId)
                }
            }

        }
    }, [offCode, cfcLevelId, roleTypeName, cscID])

    useEffect(() => {
        if (hierarchy) {
            if (hierarchy == 2 || cfcLevelId == 2) {
                let circles = subDivisions.reduce((acc, curr) => {
                    if (!acc.some(item => item.circleCode === curr.circleCode)) {
                        acc.push({ circleCode: curr.circleCode, circleName: curr.circleName });
                    }
                    return acc;
                }, []);
                setFilteredCircles(circles)
            }
            else if (hierarchy == 3 || cfcLevelId == 3) {
                setCircleCode(offCode.slice(0, 3))
                const uniqueDivisions = subDivisions
                    .filter(item => item.circleCode == offCode.slice(0, 3))
                    .reduce((acc, item) => {
                        if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName });
                        }
                        return acc;
                    }, []);
                setFilteredDivisions(uniqueDivisions);
            }
            else if (hierarchy == 4 || cfcLevelId == 4) {
                setSelectedDivision(offCode.slice(0, 4))
                const uniqueSubDivisions = subDivisions
                    .filter(item => item.divisionCode == offCode.slice(0, 4))
                    .reduce((acc, item) => {
                        if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName });
                        }
                        return acc;
                    }, []);
                setFilteredSubDivisions(uniqueSubDivisions);
            }
        }
    }, [hierarchy, cfcLevelId])

    // console.log(selectedComplaintForApi , 'selectedComplaintForApi')
    // console.log(selectedDesignationsForApi , 'SelectedDesignationsForApi')

    const exportToExcel = () => {
        let offName = officeName || 'MEPCO Region';
        let dateToPrint = convertDate(new Date());

        const formattedDateFrom = dateFrom ? convertDate(dateFrom) : '-';
        const formattedDateTo = dateTo ? convertDate(dateTo) : '-';
        const headingText = `Lineman Staff Performance Report for ${companyShortName(code.slice(0, 2))} of ${getDateDifference(dateFrom, dateTo) > 0
            ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
            : formatDate(dateFrom)
            }`;
        const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: 'Sheet1' });
        const ws = wb.Sheets['Sheet1'];

        const range = XLSX.utils.decode_range(ws["!ref"]);
        const columnCount = range.e.c - range.s.c + 1;
        XLSX.utils.sheet_add_aoa(ws, [[headingText]], { origin: "A1" });

        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];

        if (!ws["A1"]) ws["A1"] = {};
        ws["A1"].s = { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true } };

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        const fileName = `${companyShortName(code.slice(0, 2))
            } - ${getDateDifference(dateFrom, dateTo) > 0
                ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
                : formatDate(dateFrom)
            } - lineman-app-usage-summary.xlsx`;

        saveAs(new Blob([wbout]), fileName);
    };

    const connectionTypes = [
        'Name',
        'UserId',
        'Assigned',
        'Onhold',
        'Resolved',
        'Total',
        'Efficiency',
        'Avg Resolution Time'
    ];


    const [categoryName, setcategoryName] = useState('New Connections')
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));


    const getStats = async (officeCode, dateFrom, dateTo, status) => {
        console.log(officeCode, dateFrom, dateTo, status, 'getStats called')
        setViewBackdrop(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                officeCode: hierarchy == 1 ? '10' :
                    hierarchy == 2 ? code.slice(0, 2) :
                        hierarchy == 3 ? code.slice(0, 3) :
                            hierarchy == 4 ? code.slice(0, 4) : code,
                roleId: selectedDesignationsForApi ? selectedDesignationsForApi : '1135',
                dateFrom: dateFrom,
                dateTo: dateTo,
                complaintTypeId: selectedComplaintForApi ? selectedComplaintForApi : 1,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(cfpBaseUrl + "/reports/GetFieldStaffPerformance", requestOptions);
            const result = await response.json();
            const data = result.data || [];

            console.log(data, 'data')
            const updatedData = data.map((item) => {
                const assigned = item.roleId == '1135' ? parseFloat(item.pending || 0) : parseFloat(item.allocated || 0);
                const onhold = parseFloat(item.onhold || 0);
                const resolved = parseFloat(item.resolved || 0);
                const total = assigned + resolved + onhold;
                const avgResponseTime = parseFloat(item.resolved || 0);
                const efficiency = total > 0 ? ((resolved / total) * 100).toFixed(2) : "0.00";
                return {
                    ...item,
                    efficiency: efficiency,
                };
            });

            setTableData(updatedData);
        } catch (error) {
            console.error(error);
            setTableData([]);
        }
        setViewBackdrop(false);
    };

    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = subdivisionName(parseInt(code), subDivisions);
            let dateToPrint = convertDate(new Date());
            let stampData = printStamp(code, offName, name, roleName, dateToPrint);
            const title = `Lineman Staff Performance Report for ${companyShortName(code.slice(0, 2))} of ${getDateDifference(dateFrom, dateTo) > 0
                ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
                : formatDate(dateFrom)
                }`;

            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const usableWidth = pageWidth - 2 * margin;
            const logoWidth = ['12', '13', '11', '16', '27', '48', '59'].includes(companyCode) ? 25 : 30;
            const logoHeight = ['12', '13', '11', '16', '27', '48', '59'].includes(companyCode) ? 20 : 10;
            pdf.addImage(getLogo(code.slice(0, 2)), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = ['12', '13', '11', '16', '27', '48', '59'].includes(companyCode) ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, ['12', '13', '11', '16', '27', '48', '59'].includes(companyCode) ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);

            pdf.setFontSize(12);
            pdf.text(companyName(code.slice(0, 2)), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Lineman Staff Performance Report for ${companyShortName(code.slice(0, 2))}`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(title, pageWidth / 2, 25, { align: 'center' });
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text("Name: " + name, pageWidth - 65, 17);
            pdf.text("Designation: " + roleName, pageWidth - 65, 22);

            // Build headers matching the table
            const headers = [
                { content: "Name", styles: { halign: 'left' } },
                { content: "UserId", styles: { halign: 'left' } },
                { content: "Assigned", styles: { halign: 'left' } },
                { content: "Onhold", styles: { halign: 'left' } },
                { content: "Resolved", styles: { halign: 'left' } },
                { content: "Efficiency", styles: { halign: 'left' } },
                { content: "Average Resolution Time", styles: { halign: 'left' } },

            ];

            let bodyData = [];

            if (tableData && tableData.length > 0) {
                bodyData = tableData.map((item) => [
                    { content: item.name || '-', styles: { halign: 'left' } },
                    { content: item.userId || '-', styles: { halign: 'left' } },
                    { content: item.allocated || '-', styles: { halign: 'left' } },
                    { content: item.onhold || '-', styles: { halign: 'left' } },
                    { content: item.resolved || '-', styles: { halign: 'left' } },
                    { content: `${item.efficiency ? `${item.efficiency}%` : '-'}`, styles: { halign: 'left' } },
                    { content: item.avgResponseTime, styles: { halign: 'left' } },
                ]);

                const totalAssigned = tableData.reduce((sum, item) => sum + (item.allocated || 0), 0);
                const totalResolved = tableData.reduce((sum, item) => sum + (item.resolved || 0), 0);
                const totalOnhold = tableData.reduce((sum, item) => sum + (item.onhold || 0), 0);
                const totalEfficiency = totalAssigned > 0
                    ? ((totalResolved / totalAssigned) * 100).toFixed(2) + "%"
                    : "0.00%";

                bodyData.push([
                    { content: 'Total', styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                    { content: '', styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                    { content: totalAssigned.toString(), styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                    { content: totalResolved.toString(), styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                    { content: totalOnhold.toString(), styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                    { content: totalEfficiency, styles: { halign: "left", fontStyle: "bold", fillColor: "#fef5c0" } },
                ]);
            } else {
                bodyData.push([{
                    content: 'No Data Found',
                    colSpan: headers.length,
                    styles: {
                        halign: 'center',
                        fontSize: 12,
                        fontStyle: 'bold',
                        fillColor: [255, 255, 255],
                        textColor: [255, 0, 0]
                    }
                }]);
            }

            pdf.autoTable({
                startY: 28,
                head: [headers],
                body: bodyData,
                styles: { cellPadding: 3, fontSize: 8, halign: 'center' },
                theme: 'striped',
                headStyles: { fillColor: '#eeeff1', textColor: '#000000' },
                margin: { left: margin, right: margin },
                tableWidth: usableWidth,
                columnStyles: {
                    0: { cellWidth: usableWidth * 0.25, halign: 'left' },
                    1: { cellWidth: usableWidth * 0.15, halign: 'left' },
                    2: { cellWidth: usableWidth * 0.15, halign: 'left' },
                    3: { cellWidth: usableWidth * 0.15, halign: 'left' },
                    4: { cellWidth: usableWidth * 0.15, halign: 'left' },
                    5: { cellWidth: usableWidth * 0.15, halign: 'left' },
                },
            });

            // Add page numbers
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            // Save or resolve PDF
            const filename = `${companyShortName(code.slice(0, 2))
                } - ${getDateDifference(dateFrom, dateTo) > 0
                    ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
                    : formatDate(dateFrom)
                } - lineman-staff-performance.pdf`;

            if (print) {
                pdf.save(filename);
                resolve(pdf);
            } else {
                resolve(pdf);
            }
        });
    };



    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };


    useEffect(() => {
        const fetchData = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            const formdata = new FormData();
            formdata.append("companyCode", hierarchy == 1 ? companyCode : code.slice(0, 2));

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            try {
                const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);

                if (response.ok) {
                    const result = await response.json();

                    if (result.status === "200") {
                        setApiData(result.message);
                    } else {
                    }
                } else {
                    throw new Error(`Request failed with status ${response.status}`);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        // if (dateFrom, dateTo) {

        getStats(officeCode ? officeCode : '15', dateFrom, dateTo, desginationCodeToApi)
        // }
    }, [officeCode, dateFrom, dateTo, , desginationCodeToApi, companyCode])

    const handleClick = () => {
        getStats(officeCode, dateFrom, dateTo, category)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };

    const getDesgination = async () => {

        setViewBackdrop(true)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const raw = "";

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setViewBackdrop(false)
                if (result.message == 'Data Found.') {
                    setDesginationList(result.data)
                }
            })
            .catch((error) => console.error(error));
    }
    useEffect(() => {
        const getDesgination = async () => {

            setViewBackdrop(true)
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            const raw = "";

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setViewBackdrop(false)
                    if (result.message == 'Data Found.') {
                        setDesginationList(result.data)
                    }
                })
                .catch((error) => console.error(error));
        }

        getDesgination()
    }, [])

    const getComplaints = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };

        fetch("https://eopsapi.pitc.com.pk/lineComplaints/getAllComplaintTypes", requestOptions)
            .then((response) => response.json())
            .then((result) => setComplaintList(result.data || []))
            .catch((error) => console.error(error));
    };

    useEffect(() => {



        getComplaints()

    }, [])
    const getDateDifference = (startDate, endDate) => {
        // Convert the date strings to Date objects
        const startDates = startDate.split(',')[0]
        const endDates = endDate.split(',')[0]

        const start = new Date(startDates);
        const end = new Date(endDates);

        // Calculate the difference in time (milliseconds)
        const differenceInTime = end - start;

        // Convert time difference from milliseconds to days
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return differenceInDays;
    };

    const handleRemarksClick = (event, remarks) => {
        if (remarks && remarks.trim() !== '') { // Only show popover if remarks have a value
            setAnchorEl(event.currentTarget); // Set the target element for Popover
            setSelectedRemarks(remarks);
        }
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const handleChangeDesgination = (e) => {
        console.log(e.target.value, 'e.target.value')
        setDesginationCodeToApi(e.target.value)
    }


    const handleChangeCompany = (e) => {
        setCompanyCode(e.target.value)
    }

    const handleConfirm = () => {
        console.log(selectedComplaintForApi, 'selectedComplaintForApi')
        console.log(selectedDesignationsForApi, 'selectedDesignationsForApi')

        if (!selectedDesignations) {

        } else if (!selectedComplaint) {

        } else {
            getStats(code, dateFrom, dateTo, desginationCodeToApi)
        }
    };
    return (
        <>
            <Box className='form-box'>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                    <Box className='application-table' style={{ marginRight: '10px' }}>
                        <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Lineman Staff Performance Report</h3>
                        <div className='div-datagrid' >
                            <div className='reports-container' >
                                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>
                                    <div className='field-container'>
                                        <Typography className='field-label'> Date From</Typography>
                                        <input type='date' className='date-field' value={dateFrom} onChange={(e) => { setDateFrom(e.target.value); setTotals({}) }} />
                                    </div>
                                    <div className='field-container'>
                                        <Typography className='field-label'> Date To</Typography>
                                        <input type='date' className='date-field' value={dateTo}   max={new Date().toISOString().split("T")[0]} onChange={(e) => { setDateTo(e.target.value); setTotals({}) }} />
                                    </div>

                                    <div className='field-container'>
                                        <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
                                            <Typography className='field-label'>Designation</Typography>
                                            <FormControl fullWidth>
                                                {/* <InputLabel id="designation-select-label">Designation</InputLabel> */}
                                                <Select
                                                    labelId="designation-select-label"
                                                    multiple
                                                    value={selectedDesignations}
                                                    onChange={handleChange}
                                                    // input={<OutlinedInput label="Designation" />}
                                                    style={{ backgroundColor: 'white', height: 30, width: 300 }}
                                                    renderValue={(selected) =>
                                                        selected
                                                            .map((id) =>
                                                                desginationList.find((item) => item.employeeDesignationId === id)
                                                                    ?.employeeDesignationName || id
                                                            )
                                                            .join(', ')
                                                    }
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { width: 300 },
                                                        },
                                                    }}
                                                >
                                                    {desginationList.map((item) => (
                                                        <MenuItem key={item.employeeDesignationId} value={item.employeeDesignationId}>
                                                            <Checkbox checked={selectedDesignations.includes(item.employeeDesignationId)} />
                                                            <ListItemText primary={item.employeeDesignationName} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div className='field-container'>
                                        <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
                                            <Typography className='field-label'>Complaint Catagory</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    multiple
                                                    value={selectedComplaint}
                                                    onChange={handleChange1}
                                                    style={{ backgroundColor: 'white', height: 30, width: 300 }}
                                                    renderValue={(selected) =>
                                                        selected
                                                            .map(
                                                                (id) =>
                                                                    complaintList.find((item) => item.Id === id)
                                                                        ?.Name
                                                            )
                                                            .join(', ')
                                                    }
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { width: 400 },
                                                        },
                                                    }}
                                                >
                                                    {complaintList.map((item) => (
                                                        <MenuItem key={item.Id} value={item.Id}>
                                                            <Checkbox checked={selectedComplaint.includes(item.Id)} />
                                                            <ListItemText primary={item.Name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                        </div>

                                    </div>
                                    {/* <div> */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ marginTop: '10px' }}
                                        onClick={handleConfirm}
                                    >
                                        Go
                                    </Button>
                                    {/* </div> */}
                                </div>
                                <div className="export-button-container">

                                    <div onClick={DownloadPdf} style={{ height: '40px' }}>
                                        <img src={pdf} alt="pdf" style={{ ...internalIconStyles, height: '100%' }} />
                                    </div>



                                    <div onClick={printPDF} style={{ height: '40px' }}>
                                        <img src={print} alt="print" style={{ ...internalIconStyles, height: '100%' }} />
                                    </div>

                                </div>



                            </div>
                            <div className="table-container" style={{ marginBottom: '40px' }}>
                                <div id="pdf-table">
                                    <div style={{ maxHeight: '900px', overflowY: 'auto' }}>
                                        <table className="table" ref={tableRef} style={{ marginBottom: '40px', width: '100%', borderCollapse: 'collapse' }}>
                                            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
                                                <tr style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 3 }}>
                                                    <th colSpan="14" style={{ fontSize: '20px', borderBottom: '2px solid white', textAlign: 'center', backgroundColor: '#d5e5ff', color: 'black', }}>
                                                        Lineman Staff Performance Report for {companyShortName(code.slice(0, 2))} of ({getDateDifference(dateFrom, dateTo) > 0 ? formatDate(dateFrom) + ' to ' + formatDate(dateTo) : formatDate(dateFrom)})

                                                    </th>
                                                </tr>
                                                <tr style={{ position: 'sticky', top: '37px', backgroundColor: 'white', zIndex: 1 }}>
                                                    {connectionTypes.map((type, index) => (
                                                        <th
                                                            key={index}
                                                            style={{
                                                                width: `${100 / connectionTypes.length}%`,
                                                                textAlign: 'left',
                                                                border: '5px solid white',
                                                                backgroundColor: '#eeeff1',
                                                                color: 'black',
                                                                fontSize: '14px',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                            }}
                                                        >
                                                            {type}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData.length > 0 ? (
                                                    <>
                                                        {tableData.map((item, id) => (
                                                            <tr key={id} style={{ backgroundColor: "white", borderBottom: "1px solid #ccc" }}>
                                                                <td style={{ textAlign: "left" }}>{item.name || "-"}</td>
                                                                <td style={{ textAlign: "left" }}>{item.userId || "-"}</td>
                                                                <td style={{ textAlign: "left" }}>
                                                                    {item.roleId == 1135 ? (item.pending || "-") : (item.allocated || "-")}
                                                                </td>
                                                                <td style={{ textAlign: "left" }}>{item.onhold || "-"}</td>
                                                                <td style={{ textAlign: "left" }}>{item.resolved || "-"}</td>
                                                                <td style={{ textAlign: "left" }}>
                                                                    {item.roleId == 1135
                                                                        ? (parseFloat(item.pending || 0) + parseFloat(item.onhold || 0) + parseFloat(item.resolved || 0)).toString() || "-"
                                                                        : (parseFloat(item.allocated || 0) + parseFloat(item.onhold || 0) + parseFloat(item.resolved || 0)).toString() || "-"}
                                                                </td>
                                                                <td style={{ textAlign: "left" }}>{item.efficiency ? `${item.efficiency}%` : "-"}</td>
                                                                <td style={{ textAlign: "left" }}>{item.avgResponseTime || "-"}</td>
                                                            </tr>
                                                        ))}
                                                        <tr style={{ backgroundColor: "#fef5c0" }}>
                                                            <td colSpan={2} style={{ textAlign: "left" }}>Total</td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (item.roleId == 1135 ? (parseFloat(item.pending) || 0) : (parseFloat(item.allocated) || 0)), 0)}
                                                            </td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (parseFloat(item.onhold) || 0), 0)}
                                                            </td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (parseFloat(item.resolved) || 0), 0)}
                                                            </td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (item.roleId == 1135
                                                                    ? (parseFloat(item.pending) || 0) + (parseFloat(item.onhold) || 0) + (parseFloat(item.resolved) || 0)
                                                                    : (parseFloat(item.allocated) || 0) + (parseFloat(item.onhold) || 0) + (parseFloat(item.resolved) || 0)), 0)}
                                                            </td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (item.roleId == 1135 ? (parseFloat(item.pending) || 0) : (parseFloat(item.allocated) || 0)), 0) > 0
                                                                    ? (
                                                                        (tableData.reduce((sum, item) => sum + (parseFloat(item.resolved) || 0), 0) /
                                                                            tableData.reduce((sum, item) => sum + (item.roleId == 1135 ? (parseFloat(item.pending) || 0) : (parseFloat(item.allocated) || 0)), 0)) *
                                                                        100
                                                                    ).toFixed(2) + "%"
                                                                    : "0.00%"}
                                                            </td>
                                                            <td style={{ textAlign: "left" }}>
                                                                {tableData.reduce((sum, item) => sum + (parseFloat(item.avgResponseTime) || 0), 0)}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: "center", padding: "10px", fontWeight: "bold", color: "red" }}>
                                                            No Data Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Box>
            {selectedRemarks && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    disableRestoreFocus
                >
                    <div style={{ padding: '10px' }}>
                        <Typography variant="h6" sx={{ fontSize: '17px' }}>Remarks :</Typography>
                        <Typography sx={{ fontSize: '14px' }}>{selectedRemarks}</Typography>
                    </div>
                </Popover>
            )}
            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default LinemanStaffPerformance;